export interface FAQ {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    id: 'f1',
    question: '黄油在线玩是否需要下载安装？',
    answer: '不需要！黄油在线玩平台的所有游戏都支持在线即点即玩，无需下载安装任何客户端或游戏文件。只需要打开浏览器，选择你想玩的游戏，点击即可开始。我们采用先进的云游戏技术，让你随时随地畅享游戏乐趣。',
  },
  {
    id: 'f2',
    question: '平台支持哪些设备？',
    answer: '黄油在线玩支持PC端（Windows/Mac/Linux）和手机端（iOS/Android）。电脑端建议使用Chrome、Edge或Firefox浏览器获得最佳体验。手机端通过浏览器访问即可，无需下载APP，适配触屏操作。我们正在开发独立APP，届时会第一时间通知大家。',
  },
  {
    id: 'f3',
    question: '游戏是否完全免费？',
    answer: '是的，平台上所有游戏都可以免费畅玩！我们通过广告和增值服务来维持平台运营，不会向玩家收取任何游戏费用。部分游戏可能包含可选的内购内容，但核心游戏体验完全免费。VIP会员可享受去广告等额外特权，但非必须。',
  },
  {
    id: 'f4',
    question: '游戏进度会保存吗？',
    answer: '会的！平台提供云存档功能，你的游戏进度会自动保存在云端。只需注册一个免费账号，就可以在不同设备间同步存档。即使更换设备或清除浏览器缓存，你的游戏进度也不会丢失。建议每次游戏结束后手动确认存档状态。',
  },
  {
    id: 'f5',
    question: '遇到游戏卡顿或加载慢怎么办？',
    answer: '可以尝试以下方法：1）检查网络连接，确保网速稳定；2）关闭其他占用带宽的应用程序；3）在游戏设置中调低画质参数；4）清除浏览器缓存后重新加载；5）尝试使用Chrome浏览器，兼容性最佳。如果问题仍然存在，请联系客服获取帮助。',
  },
  {
    id: 'f6',
    question: '如何反馈问题或提出建议？',
    answer: '你可以通过以下方式联系我们：1）访问"关于我们"页面的在线客服；2）发送邮件至客服邮箱；3）在社区论坛的发帖反馈；4）加入官方QQ群（群号见网站首页）。我们非常重视每一位玩家的反馈，你的建议将帮助我们不断改进。',
  },
  {
    id: 'f7',
    question: '平台游戏的更新频率是怎样的？',
    answer: '我们保持每日更新的节奏！每天都会有新游戏上线，现有游戏也会定期维护和优化。大型版本更新通常在每月初进行，包含新功能和新游戏集中上线。关注我们的公告页面和社交媒体账号，第一时间获取最新游戏资讯。',
  },
  {
    id: 'f8',
    question: '是否支持手柄操作？',
    answer: '支持！大部分游戏都兼容主流手柄，包括Xbox手柄、PlayStation手柄和Switch Pro手柄。连接手柄后，游戏会自动识别并切换到手柄操作模式。你可以在游戏设置中调整手柄按键映射和灵敏度，获得最佳的操作手感。',
  },
];